<script setup lang="ts">
/** 移动端复用同一品牌和注册表导航，不另建菜单来源。 */
import type { PortalModule } from './module-registry'
import AppBrand from './AppBrand.vue'
import AppNavigation from './AppNavigation.vue'
defineProps<{ modules: PortalModule[] }>()
</script>

<template>
  <div class="app-sidebar">
    <AppBrand />
    <AppNavigation :modules="modules" stacked />
    <p class="app-sidebar__note">每一次探索，都是成长的开始。</p>
  </div>
</template>

<style scoped>
.app-sidebar__note { border-top: 1px solid var(--pf-border); padding-top: 20px; color: var(--pf-text-tertiary); font-size: 12px; }
</style>
